export const hashCode = (value: string): number => {
  const leftShift = 5;
  let hash = 0,
    i,
    chr;

  if (value.length === 0) {
    return hash;
  }

  for (i = 0; i < value.length; i++) {
    chr = value.charCodeAt(i);
    hash = ((hash << leftShift) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }

  return hash;
};
